<template>
  <div v-if="active" class="modal-container user-select-none">
    <div class="modal-overlay" @click.self="closeModal">
      <feather-icon 
        icon="XIcon" 
        class="mr-6 mt-6 cursor-pointer" 
        style="float: right !important; color:white;"
        @click="closeModal"
      />
    </div>
    <div class="modal-content">
      <inner-image-zoom 
        :src="src"
        class="user-select-none zoom-component"
        style="user-select: none !important; " 
        zoomType="click"
        :fullscreenOnMobile="true"
        :hideHint="true"
        :zoomScale="1.5"
      />
    </div>
  </div>
</template>

<script>
import InnerImageZoom from 'vue-inner-image-zoom';
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';

export default {
  props: {
    active: {
      type: Boolean,
      required: true
    },
    src: {
      type: String,
      required: true
    }
  },
  components: {
    'inner-image-zoom': InnerImageZoom
  },
  methods: {
    closeModal() {
      this.$emit('closeImage');
    },
    handleEscKey(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscKey);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscKey);
  }
};
</script>

<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}

.modal-content {
  position: relative;
  max-width: 95%;
  max-height: 95vh;
  overflow: hidden;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}

.user-select-none {
  user-select: none !important;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 24px;
  color: #fff;
}
</style>

<style>
  .modal-content .iiz__img {
  max-height: 100vh !important;
}
</style>